{
  "toast": {
    "crossDockStaged": "Cross-dock staged",
    "crossDockCompleted": "Cross-dock completed",
    "cycleCountCreated": "Cycle count created",
    "countRecorded": "Count recorded",
    "cycleCountCompleted": "Cycle count completed",
    "dockAppointmentScheduled": "Dock appointment scheduled",
    "checkedIn": "Checked in",
    "scanRecorded": "Scan recorded",
    "putawayConfirmed": "Putaway confirmed",
    "pickConfirmed": "Pick confirmed",
    "pickListCreated": "Pick list created",
    "packAndDispatchCompleted": "Pack and dispatch completed",
    "warehouseCreated": "Warehouse created",
    "zoneCreated": "Zone created",
    "binCreated": "Bin created",
    "transferCreated": "Transfer created",
    "transferSubmittedForApproval": "Transfer submitted for approval",
    "transferCancelled": "Transfer cancelled",
    "waveCreated": "Wave created",
    "waveReleased": "Wave released",
    "transferAction": "Transfer {{action}}d"
  },
  "errors": {
    "failedToLoadCrossDock": "Failed to load cross-dock",
    "stageCrossDockFailed": "Stage cross-dock failed",
    "completeCrossDockFailed": "Complete cross-dock failed",
    "failedToLoadCounts": "Failed to load counts",
    "failedToLoadCountLines": "Failed to load count lines",
    "createCycleCountFailed": "Create cycle count failed",
    "recordCountFailed": "Record count failed",
    "failedToLoadDockAppointments": "Failed to load dock appointments",
    "scheduleFailed": "Schedule failed",
    "checkInFailed": "Check-in failed",
    "failedToLoadLaborMetrics": "Failed to load labor metrics",
    "failedToLoadTasks": "Failed to load tasks",
    "scanFailed": "Scan failed",
    "putawayFailed": "Putaway failed",
    "pickFailed": "Pick failed",
    "failedToLoadPutawayTasks": "Failed to load putaway tasks",
    "failedToLoadPickLists": "Failed to load pick lists",
    "failedToLoadTransfers": "Failed to load transfers",
    "failedToLoadPicks": "Failed to load picks",
    "createPickFailed": "Create pick failed",
    "confirmPickFailed": "Confirm pick failed",
    "packDispatchFailed": "Pack/dispatch failed",
    "failedToLoadWarehouses": "Failed to load warehouses",
    "failedToLoadZonesBins": "Failed to load zones/bins",
    "createWarehouseFailed": "Create warehouse failed",
    "createZoneFailed": "Create zone failed",
    "createBinFailed": "Create bin failed",
    "createTransferFailed": "Create transfer failed",
    "submitFailed": "Submit failed",
    "cancelFailed": "Cancel failed",
    "failedToLoadWaves": "Failed to load waves",
    "createWaveFailed": "Create wave failed",
    "releaseWaveFailed": "Release wave failed",
    "transferActionFailed": "Transfer {{action}} failed"
  },
  "pages": {
    "crossDockStaging": "Cross-dock staging",
    "cycleCounts": "Cycle counts",
    "warehouseWms": "Warehouse (WMS)",
    "warehouseDetails": "Warehouse details",
    "warehouses": "Warehouses",
    "openPutaway": "Open putaway",
    "floorOperationsPicksTransfersAndMovement": "Floor operations, picks, transfers, and movement activity for your warehouses",
    "dockScheduling": "Dock scheduling",
    "laborMetrics": "Labor metrics",
    "wmsMobile": "WMS Mobile",
    "floorTasksForPutawayAndPicking": "Floor tasks for putaway and picking",
    "floorOperations": "Floor operations",
    "pickPackDispatch": "Pick / pack / dispatch",
    "warehouseSetup": "Warehouse setup",
    "warehouseTransfers": "Warehouse transfers",
    "wavePicking": "Wave picking"
  },
  "labels": {
    "warehouse": "Warehouse",
    "product": "Product *",
    "quantity": "Quantity",
    "productOptionalLine": "Product (optional line)",
    "physicalQuantity": "Physical quantity",
    "dockId": "Dock ID",
    "carrier": "Carrier",
    "startLocal": "Start (local)",
    "endLocal": "End (local)",
    "day": "Day",
    "barcode": "Barcode",
    "targetBinIdPutaway": "Target bin ID (putaway)",
    "targetBinIdOptional": "Target bin ID (optional)",
    "scanBarcode": "Scan barcode",
    "pickedQtyConfirm": "Picked qty (confirm)",
    "carrierRefDispatch": "Carrier ref (dispatch)",
    "code": "Code",
    "name": "Name",
    "type": "Type",
    "zoneCode": "Zone code",
    "zoneName": "Zone name",
    "binCode": "Bin code",
    "fromWarehouse": "From warehouse",
    "toWarehouse": "To warehouse"
  },
  "formActions": {
    "addZone": "Add zone",
    "addBin": "Add bin"
  },
  "listActions": {
    "recordScan": "Record scan"
  }
}
